module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_more.8a566.png";